<template>
  <div style="width:100%">
    <ListReminders
      :showOn="'reminders'"
      ref="reminders"
      :excludeType="'all'"
    ></ListReminders>
  </div>
</template>

<script>
import ListReminders from "@/components/reminders/ListReminders";

export default {
  name: "Reminders",
  components: {
    ListReminders
  }
};
</script>
